import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo, useRef } from 'react';
import { propArrayShape } from '../../../../helpers/custom-prop-types';
import { useBoolState } from '../../../../helpers/use/useHook';
import ArrowNextIcon from '../../../Icon/Svg/ArrowNextIcon';
import ArrowPrevIcon from '../../../Icon/Svg/ArrowPrevIcon';
import Hover from '../../../Ui/System/Hover';
import SlideSearchTopMySlideEmpty from './SlideSearchTopMySlideEmpty';
import SlideSearchTopMySlideListItem from './SlideSearchTopMySlideListItem';
const SlideSearchTopMySlideList = (props) => {
    const { slides, uploadItems } = props;
    const viewItems = useMemo(() => {
        const existSlideIdList = slides.map((v) => v.id);
        const filterUploadItems = uploadItems.filter((v) => !existSlideIdList.includes(v.slideId));
        return [
            ...filterUploadItems.map((value) => ({
                type: 'upload',
                value,
            })),
            ...slides.map((value) => ({
                type: 'slide',
                value,
            })),
        ];
    }, [slides, uploadItems]);
    const slideScrollRef = useRef(null);
    const { boolState: showButtonState, changeFalse: hideButton, changeTrue: showButton, } = useBoolState(false);
    /**
     * 新着スライドをスクロールする
     * @type {(function(*): void)|*}
     */
    const updateSlideScroll = useCallback((e) => {
        const { value } = e.currentTarget;
        const rowsBox = slideScrollRef.current;
        if (!rowsBox) {
            // refが存在しない場合は何もしない
            return;
        }
        const rowOffsetWidth = 200;
        const index = rowsBox.scrollLeft / rowOffsetWidth;
        const rawUpdateIndex = index + (value === 'prev' ? -1 : 1);
        const mathUpdateIndex = value === 'prev'
            ? Math.ceil(rawUpdateIndex)
            : Math.floor(rawUpdateIndex);
        const updateIndex = Math.max(0, mathUpdateIndex);
        rowsBox.scrollTo({
            behavior: 'smooth',
            left: rowOffsetWidth * updateIndex,
        });
    }, [slideScrollRef]);
    const onMouseEnter = useCallback(() => {
        const rowsBox = slideScrollRef.current;
        if (!rowsBox) {
            return;
        }
        if (rowsBox.scrollWidth > rowsBox.clientWidth) {
            showButton();
        }
    }, [slideScrollRef, showButton]);
    if (slides.length + uploadItems.length === 0) {
        return _jsx(SlideSearchTopMySlideEmpty, {});
    }
    return (_jsx(Hover, Object.assign({ onMouseEnter: onMouseEnter, onMouseLeave: hideButton }, { children: _jsxs("div", { children: [showButtonState && (_jsx("button", Object.assign({ className: 'my_slide_uploaded_scroll_btn prev', onClick: updateSlideScroll, type: 'button', value: 'prev' }, { children: _jsx(ArrowPrevIcon, {}) }))), _jsx("div", Object.assign({ className: 'scroll_area', ref: slideScrollRef }, { children: _jsx("ul", Object.assign({ className: 'slide_list' }, { children: viewItems.map(({ type, value }, index) => {
                            if (type === 'upload') {
                                return (_jsx(SlideSearchTopMySlideListItem, { index: index, progress: value.progress, type: 'processing' }, value.itemId));
                            }
                            return (_jsx(SlideSearchTopMySlideListItem, { index: index, item: value, type: 'uploaded' }, value.id));
                        }) })) })), showButtonState && (_jsx("button", Object.assign({ className: 'my_slide_uploaded_scroll_btn next', onClick: updateSlideScroll, type: 'button', value: 'next' }, { children: _jsx(ArrowNextIcon, {}) })))] }) })));
};
SlideSearchTopMySlideList.propTypes = {
    slides: propArrayShape().isRequired,
    uploadItems: propArrayShape().isRequired,
};
export default SlideSearchTopMySlideList;
